/**
* Created by kongwm.kong on 2017/7/31.
*/
<template>
    <div class="addManager-wrap clearfix" >
        <div class="manager-wrap">
            <vue-select @closed="closed" :selectKey="selectKey" :readonly="obj.readonly || readonly" :id="manaObj.managerCode" :isIgnoreWatch="isIgnoreWatch" :idSelectName="'fundDcId'"  :disabled="obj.readonly || readonly" v-model="manaObj.name" @selected="selectName" :selectList="managerList"></vue-select>
        </div>
        <div class="time-wrap">
            <div class="input-mana" >
                <date-picker class="date-time"  @selected="selectTimes"  language="zh" :disabled-picker="obj.readonly || readonly"  v-model="manaObj.managementStartDate"  :input-class="'date-picker-input'" :format="'yyyy-MM-dd'" placeholder="请输入入职时间"></date-picker>
            </div>
            <span>至</span>
            <div class="input-mana">
                <date-picker class="date-time"  @selected="selectTimee" language="zh" :disabled-picker="obj.readonly || readonly"  v-model="manaObj.managementEndDate"  :input-class="'date-picker-input'" :format="'yyyy-MM-dd'" placeholder="请输入离职时间"></date-picker>
            </div>
        </div>
        <div class="delete-wrap" v-show="!item.isDelete" @click="deleteManager"></div>
    </div>

</template>
<script>
//    import datePicker from 'vuejs-datepicker';
    import datePicker from '../../components/middleware/Datepicker';
    import vueSelect from '../../components/form/select'
    export default {
        props:{
            index:{

            },
            totalLen:{
                type: Number,
                required: false
            },
            item:{
                type: Object,
                required: true
            },
            selectKey: {
                type: String,
                required: true
            },
            selectList: {
                type: Array,
                required: true
            },
            readonly:{
                default: false
            }
        },
        components:{
            datePicker,
            vueSelect
        },
        data(){
            return {
//                managerList: this.selectList,
                idx: this.index,

            }
        },
        computed: {
            obj(){
                return  this.item;
            },
            manaObj(){
                return this.item
            },
            managerList(){
//                console.log(this.selectList);
                return this.selectList
            },
            /*是否要忽略select的变化，防止添加下一个经理的时候 上面的经理被清空, 返回true 就是要忽视 返回false就是不要忽视*/
            isIgnoreWatch(){
                return !(this.index!=0 && this.index==this.totalLen-1)
            },
        },
        methods:{
            selectName(obj){
//                console.log(this.manaObj.name);
                this.manaObj.managerCode = obj.fundDcId;
                obj.index = this.index;
                this.$emit('selectedMan', obj);
            },
            selectTimee(time){
                let obj ={
                    index: this.index,
                    managementEndDate : new Date(time).getTime()
                };
                this.$emit('selectedMan', obj);
            },
            selectTimes(time){
                let obj ={
                    index: this.index,
                    managementStartDate : new Date(time).getTime()
                };
                this.$emit('selectedMan', obj);
            },
            closed(){

            },
            /*删除经理*/
            deleteManager(){
                let obj ={
                    index: this.index
                };
                this.$emit('deleteManager',obj);
            },
        }
    }
</script>
<style lang="scss" type="text/scss" scoped>
.addManager-wrap{
    /*position: absolute;*/
    top:0;
    left:0;
    right:0;
    bottom:0;
    height:100%;
    position: relative;
    .manager-wrap{
        width:260px;
        height:35px;
        float: left;
        /*border: 1px solid $border_bfb;*/
        border-radius: 4px;
        input{
            text-indent: 10px;
            width:100%;
            height:100%;
            padding: 5px 0;
            line-height: 1;
            border-radius:4px;
        }
    }
    .time-wrap{
        float: right;
        margin-right: 70px;
        .input-mana{
            display: inline-block;
            width:260px;
            height:35px;
            /*padding: 5px 0;*/
            border: 1px solid $border_bfb;
            text-indent: 10px;
            border-radius:4px;
        }
        span{
            margin: 0 3px;
        }
    }
    .delete-wrap{
        position: absolute;
        top:0;
        right: 0;
        width: 20px ;
        height: 100%;
        background: url(../../assets/img/common/del.png) no-repeat center center;
        &:hover{
            background-image: url(../../assets/img/common/delact.png);
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/form/addManager.vue